import { createContext, useContext } from 'react';

interface AdminLayoutContextValue {
  onMobileMenuClick: () => void;
  themeMode: 'light' | 'dark';
  setThemeMode: (mode: 'light' | 'dark') => void;
}

export const AdminLayoutContext = createContext<AdminLayoutContextValue | null>(null);

export const useAdminLayout = (): AdminLayoutContextValue => {
  const ctx = useContext(AdminLayoutContext);
  if (!ctx) throw new Error('useAdminLayout must be used inside AdminLayout');
  return ctx;
};
